export default "__VITE_PUBLIC_ASSET__648c9c19__"